import React from 'react';

import { useMountedState } from '@gogame/hooks-ts';

import BudgetGrid from 'scenes/MarketingPlanning/MarketingPlanningWizard/MarketingPlanningForm/components/BudgetGrid';
import NodesBudget from 'scenes/MarketingPlanning/MarketingPlanningWizard/MarketingPlanningForm/components/NodesBudget';
import { useActivityTypes } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/PlanSettings';
import { ValidationErrors } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Validation';
import { useParamsEntityIds } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/ViewState';
import { CHANNELS } from 'scenes/MarketingPlanning/MarketingPlanningWizard/constants';
import { loadChannels } from 'scenes/MarketingPlanning/MarketingPlanningWizard/sources/fields';

const ApplicationLevel = () => {
  const { networkId, applicationId } = useParamsEntityIds();
  const activityTypes = useActivityTypes();

  const [channelsList, setChannelsList] = useMountedState([]);

  React.useEffect(() => {
    loadChannels({ networkId, applicationId, activityTypes }).then(
      setChannelsList
    );
  }, [networkId, applicationId, activityTypes]);

  return (
    <React.Fragment>
      <BudgetGrid withAllocatedReBudgetLeft={false} />
      <ValidationErrors />
      <NodesBudget
        levelName={CHANNELS}
        subLevelList={channelsList}
        addNodesActionLabel={'Channels'}
      />
    </React.Fragment>
  );
};

export default ApplicationLevel;
